import { SortClockAscendingIcon } from './SortClockAscendingIcon';

/**
 * author: Michael Irigoyen
 * id 2A4F548A-F4C1-48F2-BFB1-A6A1ACB794A6
 * name sort-clock-ascending
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-clock-ascending.svg
 * tags
 * - Text / Content / Format 
 * - Date / Time 
 */
export const SortTimeAscendingIcon = SortClockAscendingIcon;
export default SortTimeAscendingIcon